import {
  checkResetPasswordToken,
  checkResetPasswordTokenVariables,
  getCode,
  getCodeVariables,
  login,
  loginVariables,
  resetPassword,
  resetPasswordVariables,
  signupUser,
  signupUserVariables,
  switchProfile,
  switchProfileVariables,
  updatePassword,
  updatePasswordVariables,
  viewAsUser,
  viewAsUserVariables,
} from "#types/code-generator.ts";
import type { TypedDocumentNode } from "#types/graphql.d.ts";
import { gql } from "graphql-tag";
import { UserPayloadFragment } from "./User";

export const SignupUserMutation = gql`
  mutation signupUser($data: SignupUserInput!) {
    signupUser(data: $data) {
      token
      user {
        ...UserPayload
      }
      isNewOrg
    }
  }
  ${UserPayloadFragment}
` as TypedDocumentNode<signupUser, signupUserVariables>;

export const LoginUserMutation = gql`
  mutation login($data: LoginInput!) {
    login(data: $data) {
      token
      user {
        ...UserPayload
      }
      isNewOrg
    }
  }
  ${UserPayloadFragment}
` as TypedDocumentNode<login, loginVariables>;

export const ResetPasswordMutation = gql`
  mutation resetPassword($data: ResetPasswordInput!) {
    resetPassword(data: $data) {
      success
    }
  }
` as TypedDocumentNode<resetPassword, resetPasswordVariables>;

export const UpdatePasswordMutation = gql`
  mutation updatePassword($data: UpdatePasswordInput!) {
    updatePassword(data: $data) {
      token
      user {
        ...UserPayload
      }
    }
  }
  ${UserPayloadFragment}
` as TypedDocumentNode<updatePassword, updatePasswordVariables>;

export const ViewAsUserMutation = gql`
  mutation viewAsUser($userId: ID!) {
    viewAsUser(userId: $userId) {
      token
      user {
        ...UserPayload
      }
    }
  }
  ${UserPayloadFragment}
` as TypedDocumentNode<viewAsUser, viewAsUserVariables>;

export const CheckResetPasswordTokenQuery = gql`
  query checkResetPasswordToken($token: String!) {
    checkResetPasswordToken(token: $token)
  }
` as TypedDocumentNode<
  checkResetPasswordToken,
  checkResetPasswordTokenVariables
>;

export const GetCodeQuery = gql`
  mutation getCode(
    $email: String
    $sms: Boolean
    $organizationId: ID!
    $asLink: Boolean
  ) {
    getCode(
      email: $email
      sms: $sms
      organizationId: $organizationId
      asLink: $asLink
    )
  }
` as TypedDocumentNode<getCode, getCodeVariables>;

export const SwitchProfileMutation = gql`
  mutation switchProfile($organizationId: ID!) {
    switchProfile(organizationId: $organizationId) {
      token
      user {
        ...UserPayload
      }
    }
  }
  ${UserPayloadFragment}
` as TypedDocumentNode<switchProfile, switchProfileVariables>;
